<template>
  <v-layout
    justify-center
    class="mb-5 text-xs-center">
    <v-date-picker 
      v-model="date" 
      first-day-of-week="1"
      class="mt-3 roundedcard"
      :min="dateToday"
      locale="locale"
      scrollable
      :reactive="reactive"
      :no-title="false"
      style="margin: 0 12px">
    </v-date-picker>
  </v-layout>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data() {
    return {
      // date: new Date().toISOString().substr(0, 10),
      reactive: true,
      dateCurrent: null,
      dateFormatted: null,
      dateToday: new Date().toISOString().substr(0, 10),
    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      timelineFilter: state => state.timeline.timelineFilter,

    }),
    date: {
      get() {
        return this.timelineFilter.dateFilter
      },
      set(value) {
        this.setFilter({ dateFilter : value })
      }
    }
  },
  methods: {
    ...mapMutations([
      'setFilter',
    ]),
    // toTimelineFilter() {
    //   this.setFilter({ dateFilter: this.date })
    // }
    
  }
}
</script>
